import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { AdBanner } from '../ads';
import { useLocation } from 'react-router-dom';

/**
 * Page Layout with Integrated Ad Placements
 * Wraps page content with ads in strategic positions
 * 
 * @param {ReactNode} children - Page content
 * @param {boolean} showTopBanner - Show top banner ad
 * @param {boolean} showSidebar - Show sidebar with ads
 * @param {boolean} showBottomSticky - Show bottom sticky ad
 * @param {string} maxWidth - Container max width
 */
const PageLayoutWithAds = ({ 
  children, 
  showTopBanner = true,
  showSidebar = false,
  showBottomSticky = true,
  maxWidth = 'xl',
  ...props 
}) => {
  const location = useLocation();

  // Don't show ads during exam attempts
  const isExamPage = location.pathname.includes('/attempt');
  
  if (isExamPage) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth={maxWidth} sx={{ flex: 1, py: 3 }}>
        {/* Top Banner Ad */}
        {showTopBanner && (
          <Box sx={{ mb: 3 }}>
            <AdBanner placement="topBanner" />
          </Box>
        )}

        {/* Main Content Area */}
        {showSidebar ? (
          <Grid container spacing={3}>
            {/* Main Content */}
            <Grid item xs={12} md={9}>
              {children}
            </Grid>

            {/* Sidebar with Ads */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  position: { md: 'sticky' },
                  top: { md: 80 },
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                }}
              >
                <AdBanner placement="sidebarBanner" />
                {/* Additional sidebar ads can be added here */}
              </Box>
            </Grid>
          </Grid>
        ) : (
          <>{children}</>
        )}
      </Container>

      {/* Bottom Sticky Ad */}
      {showBottomSticky && (
        <AdBanner placement="bottomSticky" />
      )}
    </Box>
  );
};

export default PageLayoutWithAds;
